/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css2?family=Muli:ital,wght@0,400;0[_ngcontent-%COMP%], 500[_ngcontent-%COMP%];0[_ngcontent-%COMP%], 700[_ngcontent-%COMP%];1[_ngcontent-%COMP%], 400&display=swap)[_ngcontent-%COMP%];.download-icon[_ngcontent-%COMP%]{background-color:#21d196;border-radius:100%;padding:3px;color:#fff;line-height:10px}.material-icons[_ngcontent-%COMP%]{font-size:14px}mat-table[_ngcontent-%COMP%]{max-height:290px;overflow-y:auto}cc-empty-table-message[_ngcontent-%COMP%]{margin-bottom:10px}"];
export { styles as styles };
